// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * How an IDL array declaration expanded into consecutive ids.
 */
export enum Expansion {
  None = 0,
  PerController = 1,
  PerFloor = 2,
}
